import { render } from "./ReportHistoryComponent.vue?vue&type=template&id=7d40d428"
import script from "./ReportHistoryComponent.vue?vue&type=script&lang=js"
export * from "./ReportHistoryComponent.vue?vue&type=script&lang=js"

import "./ReportHistoryComponent.vue?vue&type=style&index=0&id=7d40d428&lang=scss"
script.render = render

export default script